// Semantic-UI specific inits

$(function() {
  // Installation form
  $('.ui.checkbox').checkbox();
  $('#SmartWindow').checkbox({
    onChecked: function() {
      $('#sensors.field').removeClass('disabled');
    },
    onUnchecked: function(){
      $('#sensors.field').addClass('disabled');
      $('#sensors .ui.checkbox').checkbox("set unchecked");
    }
  });

  // Messages
  $('.message.error').transition('shake', '1000ms');
  $('.message.success').transition('bounce', '1000ms');

  $('.message').on('click', () => {
    $(this).transition('fade');
  });

  $('.ui.embed').embed();
  $('.ui.modal').modal({
    observeChanges: true
  });
  // Invite Ambassador btn
  $('#enlist_ambassador').on('click', () => {
    $('#ambassador_modal.ui.modal').modal('show');
  });
  // conatc PHYSEE btn
  $('#contact_physee').on('click', () => {
    $('#contact_modal.ui.modal').modal('show');
  });

  $('#ambassador_modal .actions .cancel').on('click', () => {
    $('#ambassador-form').trigger('reset');
  });

  // $(document).bind(
  //       'touchmove',
  //           function(e) {
  //             e.preventDefault();
  //           }
  // );
});


// WEBPACK FOOTER //
// ./public/javascripts/modules/physee-semantic.js